import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip,
  ResponsiveContainer, CartesianGrid, Cell
} from 'recharts';
import { Typography, Card, CardContent } from '@material-ui/core';

const COLORS = ['#90caf9', '#64b5f6', '#42a5f5', '#1e88e5', '#1565c0'];

const FrequencyBarChart = ({ distribution, title = "Fréquence de commande" }) => {
  const data = [
    { name: '1', fullName: '1 commande', value: distribution?.['1_commande'] || 0 },
    { name: '2-3', fullName: '2-3 commandes', value: distribution?.['2_3_commandes'] || 0 },
    { name: '4-5', fullName: '4-5 commandes', value: distribution?.['4_5_commandes'] || 0 },
    { name: '6-10', fullName: '6-10 commandes', value: distribution?.['6_10_commandes'] || 0 },
    { name: '10+', fullName: '10+ commandes', value: distribution?.['plus_10_commandes'] || 0 },
  ];

  const total = data.reduce((sum, item) => sum + item.value, 0);

  return (
    <Card style={{ height: '100%' }}>
      <CardContent>
        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
          {title}
        </Typography>
        <Typography variant="caption" color="textSecondary" style={{ marginBottom: 8, display: 'block' }}>
          {total} utilisateurs sur la période
        </Typography>
        <ResponsiveContainer width="100%" height={200}>
          <BarChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis
              dataKey="name"
              tick={{ fontSize: 12 }}
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              allowDecimals={false}
              tick={{ fontSize: 12 }}
              axisLine={false}
              tickLine={false}
              width={40}
            />
            <Tooltip
              formatter={(value, name, props) => [
                `${value} utilisateurs`,
                props.payload.fullName
              ]}
              contentStyle={{ fontSize: 12 }}
            />
            <Bar dataKey="value" radius={[4, 4, 0, 0]}>
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index]} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default FrequencyBarChart;
